import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ModalController, IonNav } from '@ionic/angular';
import { TranslocoPipe } from '@jsverse/transloco';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { ButtonComponent } from '@app/shared/ui/button/button.component';

@Component({
  selector: 'c-modal-header',
  imports: [TranslocoPipe, ButtonComponent],
  templateUrl: './modal-header.component.html',
  styleUrl: './modal-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalHeaderComponent {
  @Input({ required: true }) title: string;
  @Input() isRoot = false;

  private readonly nav = inject(IonNav, { optional: true });
  private readonly modalCtrl = inject(ModalController);

  readonly backIcon = faChevronLeft;

  back(): void {
    if (this.isRoot) {
      this.modalCtrl.dismiss();
    } else {
      this.nav?.pop();
    }
  }
}
